<template>


<!-- Diálogo de Loading Moderno -->
<v-dialog 
  v-model="loadingDialog" 
  persistent 
  max-width="420" 
  overlay-opacity="0.7"
  transition="dialog-transition"
>
  <v-card class="loading-card elevation-24 rounded-xl overflow-hidden">
    <!-- Gradiente de fundo animado -->
    <div class="loading-background"></div>
    
    <v-card-text class="text-center pa-10 position-relative">
      
      <!-- Mensagem principal -->
      <div class="text-h5 font-weight-medium mb-3 loading-title">
        <span class="typing-animation">{{ tituloDialog || 'Processando' }}</span>
      </div>
      
      <!-- Mensagem dinâmica -->
      <div class="text-body-1 mb-4 loading-subtitle">
        {{ mensagemDialog || 'Aguarde um momento...' }}
      </div>
      
      <!-- Barra de progresso estilizada -->
      <div class="progress-container">
        <v-progress-linear 
          indeterminate 
          color="primary" 
          height="4"
          rounded
          class="loading-progress"
        ></v-progress-linear>
      </div>
      
      <!-- Pontos animados -->
      <div class="loading-dots mt-4">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
    </v-card-text>
  </v-card>
</v-dialog>
  
  <!-- Estilos para animação -->
 

 <!-- Modal de Sucesso -->
<v-dialog 
  v-model="modalSucesso" 
  persistent 
  max-width="450"
  overlay-opacity="0.5"
>
  <v-card class="elevation-8 rounded-lg">
    <v-card-title class="text-center pa-6 pb-4">
      <div class="d-flex flex-column align-center">
        <v-icon 
          size="48" 
          color="success" 
          class="mb-3"
        >
          mdi-check-circle
        </v-icon>
        <div class="text-h5 font-weight-medium">
          Operação Realizada com Sucesso
        </div>
      </div>
    </v-card-title>
    
    <v-card-text class="text-center pa-6 pt-2">
      <div class="mb-4">
        <div class="text-caption text-medium-emphasis mb-1">
          Chamado Nº
        </div>
        <div class="text-h3 font-weight-bold text-success">
          {{ chamadoAtual?.id }}
        </div>
      </div>
      
      <div class="text-body-1 text-medium-emphasis">
        {{ mensagemDialog }}
      </div>
    </v-card-text>
    
    <v-card-actions class="pa-6 pt-2">
      <v-spacer></v-spacer>
      <v-btn 
        color="success" 
        variant="elevated"
        size="large"
        class="px-8"
        @click="fetchChamados"
      >
        OK
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

  <!-- Diálogo de Início de Trabalho -->
  <v-dialog v-model="dialogInicioTrabalho" max-width="500" persistent>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon left color="white">mdi-play</v-icon>
        Iniciar Trabalho - Chamado #{{ chamadoAtual?.id }}
      </v-card-title>
      <v-card-text class="pa-4">
        <v-alert type="info" outlined class="mb-3">
          <strong>Observação da Abertura:</strong>
        </v-alert>
        <div class="text-body-1">{{ chamadoAtual?.observacao_abertura }}</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialogInicioTrabalho = false">Cancelar</v-btn>
        <v-btn color="primary" @click="confirmarInicioTrabalho">Confirmar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Diálogo de Execução em Curso -->
  <v-dialog v-model="dialogExecucaoCurso" max-width="600" persistent>
    <v-card>
      <v-card-title class="warning white--text">
        <v-icon left color="white">mdi-cog</v-icon>
        Execução em Curso - Chamado #{{ chamadoAtual?.id }}
      </v-card-title>
      <v-card-text class="pa-4">
        <v-alert type="info" outlined class="mb-3">
          <strong>Observação da Abertura:</strong>
          <div class="mt-1">{{ chamadoAtual?.observacao_abertura }}</div>
        </v-alert>
        <v-textarea 
          v-model="observacaoMecanico" 
          label="Observação do Atendimento" 
          outlined
          rows="4"
          counter
          clearable
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="info" @click="openMachineDialog(chamadoAtual)">
          <v-icon left>mdi-eye</v-icon>
          Ver Máquina
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click="dialogExecucaoCurso = false">Cancelar</v-btn>
        <v-btn color="warning" @click="confirmarExecucaoCurso">Confirmar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Diálogo de Finalização -->
  <v-dialog v-model="dialogFinalizarAtendimento" max-width="600" persistent>
    <v-card>
      <v-card-title class="success white--text">
        <v-icon left color="white">mdi-check</v-icon>
        Finalizar Chamado #{{ chamadoAtual?.id }}
      </v-card-title>
      <v-card-text class="pa-4">
        <v-row>
          <v-col cols="12">
            <v-alert type="info" outlined class="mb-3">
              <strong>Observação da Abertura:</strong>
              <div class="mt-1">{{ chamadoAtual?.observacao_abertura }}</div>
            </v-alert>
          </v-col>
          <v-col cols="12" v-if="chamadoAtual?.observacao_mecanico">
            <v-alert type="warning" outlined class="mb-3">
              <strong>Observação do Mecânico:</strong>
              <div class="mt-1">{{ chamadoAtual?.observacao_mecanico }}</div>
            </v-alert>
          </v-col>
          <v-col cols="12">
            <v-textarea 
              v-model="observacaoFinalizarAtendimento" 
              label="Observação de Finalização" 
              outlined
              rows="4"
              counter
              clearable
              required
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-radio-group v-model="idStatusFinalizacao" mandatory>
              <template v-slot:label>
                <strong>Status de Finalização:</strong>
              </template>
              <v-radio 
                label="Encerrado com Problemas" 
                :value="5"
                color="error"
              ></v-radio>
              <v-radio 
                label="Finalizado com Sucesso" 
                :value="6"
                color="success"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="fecharDialogFinalizacao">Cancelar</v-btn>
        <v-btn 
          color="success" 
          :disabled="!observacaoFinalizarAtendimento || !idStatusFinalizacao"
          @click="confirmarFinalizarAtendimento"
        >
          Finalizar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Diálogo WhatsApp -->
  <v-dialog v-model="dialogWatzap" max-width="800" persistent>
    <v-card class="elevation-12">
      <!-- Header com gradiente -->
      <v-card-title class="pa-0">
        <div class="w-100 pa-4" style="background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);">
          <div class="d-flex align-center">
            <v-avatar size="40" class="mr-3" style="background: rgba(255,255,255,0.2);">
              <v-icon color="white" size="24">mdi-whatsapp</v-icon>
            </v-avatar>
            <div>
              <div class="white--text text-h6 font-weight-medium">
                Enviar WhatsApp
              </div>
              <div class="white--text text-caption" style="opacity: 0.9;">
                Chamado #{{ chamadoAtual?.id }}
              </div>
            </div>
          </div>
        </div>
      </v-card-title>

      <v-card-text class="pa-6">
        <!-- Seção da Mensagem -->
        <div class="mb-6">
          <div class="text-h6 mb-3 d-flex align-center">
            <v-icon color="grey darken-1" class="mr-2">mdi-message-text</v-icon>
            Mensagem
          </div>
          <v-textarea 
            v-model="mensagemWhatzap" 
            placeholder="Digite sua mensagem aqui..."
            outlined
            rows="5"
            counter
            clearable
            hide-details="auto"
            class="rounded-lg"
          ></v-textarea>
        </div>
        
        <!-- Seção dos Destinatários -->
        <div>
          <div class="text-h6 mb-3 d-flex align-center">
            <v-icon color="grey darken-1" class="mr-2">mdi-account-multiple</v-icon>
            Destinatários
            <v-chip 
              small 
              color="primary" 
              class="ml-2"
              v-if="pessoasReceberMensagens?.filter(p => p.selecionado).length > 0"
            >
              {{ pessoasReceberMensagens.filter(p => p.selecionado).length }} selecionado(s)
            </v-chip>
          </div>
          
          <v-card outlined class="rounded-lg">
            <v-card-subtitle class="pb-2">
              <v-icon small class="mr-1">mdi-wrench</v-icon>
              Mecânicos Disponíveis
            </v-card-subtitle>
            
            <v-divider></v-divider>
            
            <div class="pa-2" style="max-height: 300px; overflow-y: auto;">
              <v-list dense class="pa-0">
                <v-list-item 
                  v-for="pessoa in pessoasReceberMensagens" 
                  :key="pessoa.id"
                  class="rounded-lg ma-1"
                  :class="pessoa.selecionado ? 'primary lighten-5' : ''"
                >
                  <template v-slot:prepend>
                    <v-checkbox 
                      v-model="pessoa.selecionado"
                      color="primary"
                      hide-details
                    ></v-checkbox>
                  </template>
                  
                  <v-list-item>
                    <v-list-item-title class="font-weight-medium">
                      {{ pessoa.nome }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="d-flex align-center">
                      <v-icon small class="mr-1" color="grey">mdi-phone</v-icon>
                      {{ pessoa.celular || "Sem celular informado" }}
                    </v-list-item-subtitle>
                  </v-list-item>
                  
                  <v-list-item-action v-if="pessoa.selecionado">
                    <v-icon color="primary">mdi-check-circle</v-icon>
                  </v-list-item-action>
                </v-list-item>
                
                <div v-if="!pessoasReceberMensagens || pessoasReceberMensagens.length === 0" 
                     class="text-center pa-4 grey--text">
                  <v-icon large color="grey lighten-1">mdi-account-off</v-icon>
                  <div class="mt-2">Nenhum mecânico disponível</div>
                </div>
              </v-list>
            </div>
          </v-card>
        </div>
      </v-card-text>
      
      <v-divider></v-divider>
      
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn 
          text 
          large
          @click="fecharDialogWhatsapp"
          class="mr-2"
        >
          <v-icon left>mdi-close</v-icon>
          Cancelar
        </v-btn>
        <v-btn 
          color="#25D366"
          dark
          large
          elevation="2"
          :disabled="!mensagemWhatzap || !pessoasReceberMensagens?.some(p => p.selecionado)"
          @click="confirmarWhatzap"
          class="px-6"
        >
          <v-icon left>mdi-send</v-icon>
          Enviar Mensagem
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Diálogo de Cancelamento -->
  <v-dialog v-model="dialogCancelarChamado" max-width="500" persistent>
    <v-card>
      <v-card-title class="error white--text">
        <v-icon left color="white">mdi-close-circle</v-icon>
        Cancelar Chamado #{{ chamadoAtual?.id }}
      </v-card-title>
      <v-card-text class="pa-4">
        <v-textarea 
          v-model="observacaoCancelamento" 
          label="Motivo do Cancelamento" 
          outlined
          rows="4"
          counter
          clearable
          required
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="fecharDialogCancelamento">Cancelar</v-btn>
        <v-btn 
          color="error" 
          :disabled="!observacaoCancelamento"
          @click="cancelarChamado"
        >
          Confirmar Cancelamento
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Conteúdo Principal -->
  <v-container fluid v-if="!loadingDialog">
    <!-- Cabeçalho com Filtros -->
    <v-card class="mb-4" elevation="2">
      <v-card-title class="primary white--text">
        <v-icon left color="white">mdi-wrench</v-icon>
        <span>Gerenciamento de Chamados</span>
        <v-spacer></v-spacer>
        <v-btn 
          v-if="isMobile" 
          color="white" 
          text 
          @click="filtrosDialogVisible = true"
        >
          <v-icon left>mdi-filter-variant</v-icon>
          Filtros
        </v-btn>
      </v-card-title>

      <!-- Filtros Desktop -->
      <v-card-text v-if="!isMobile">
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="search"
              label="Buscar"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              clearable
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="filtroTipoManutencao"
              :items="tiposDeManutencao"
              label="Tipo de Manutenção"
              outlined
              dense
              clearable
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="filtroPrioridade"
              :items="prioridades"
              label="Prioridade"
              outlined
              dense
              clearable
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="filtroStatus"
              :items="statusChamados"
              label="Status"
              outlined
              dense
              clearable
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="filtroMecanico"
              :items="mecanicosDosChamados"
              label="Mecânico"
              outlined
              dense
              clearable
              hide-details
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- Botões de Ação -->
      <v-card-actions>
        <v-btn 
          color="primary" 
          :disabled="usuarioMecanico"
          @click="abrirChamado"
        >
          <v-icon left>mdi-plus</v-icon>
          Novo Chamado
        </v-btn>
        
        <v-btn color="info" @click="fetchChamados">
          <v-icon left>mdi-refresh</v-icon>
          Atualizar
        </v-btn>
        
        <v-btn color="warning" @click="limparFiltros">
          <v-icon left>mdi-filter-off</v-icon>
          Limpar Filtros
        </v-btn>
        
        <v-spacer></v-spacer>
        
        <v-btn color="secondary" @click="voltarMenu">
          <v-icon left>mdi-arrow-left</v-icon>
          Voltar
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Tabela Desktop -->
    <v-card v-if="!isMobile" elevation="2">
      <v-data-table
        :headers="headers"
        :items="filteredChamados"
        :search="search"
        :items-per-page="options.itemsPerPage"
        item-key="id"
        class="elevation-0"
        :loading="loadingDialog"
      >
        <!-- Templates dos slots da tabela -->
        <template v-slot:item.data_abertura="{ item }">
          <v-chip small color="info" text-color="white">
            {{ formatarDataHora(item.data_abertura) }}
          </v-chip>
        </template>

        <template v-slot:item.funcionario_abertura.nome="{ item }">
          <div class="d-flex align-center">
            <v-avatar size="24" color="primary" class="mr-2">
              <span class="white--text text-caption">
                {{ item.funcionario_abertura.nome.charAt(0) }}
              </span>
            </v-avatar>
            {{ item.funcionario_abertura.nome }}
          </div>
        </template>

        <template v-slot:item.prioridade.prioridade="{ item }">
          <v-chip 
            small 
            :color="getPrioridadeColor(item.prioridade.id)"
            text-color="white"
          >
            {{ item.prioridade.prioridade }}
          </v-chip>
        </template>

        <template v-slot:item.status_chamado.descricao_status="{ item }">
          
            {{ item.status_chamado.descricao_status }} <br>
            {{ item.mecanico.nome_mecanico }}
         </template>

        <template v-slot:item.maquina.descricao_maquina="{ item }">
          <div class="d-flex justify-space-between align-center">
            <span>{{ item.maquina.descricao_maquina }}</span>
            <v-btn 
              small 
              color="info" 
              text 
              @click="openMachineDialog(item)"
            >
              <v-icon small>mdi-eye</v-icon>
            </v-btn>
          </div>
        </template>

        <template v-slot:item.tempo_chamado_aberto="{ item }">
          <v-chip small outlined>
            {{ item.tempo_chamado_aberto }} min
          </v-chip>
        </template>

        <template v-slot:item.observacao_abertura="{ item }">
          <div 
            style="max-width: 300px; cursor: pointer;"
            class="text-truncate"
            @click="showObservacao(item.observacao_abertura)"
            :title="item.observacao_abertura"
          >
            {{ item.observacao_abertura }}
          </div>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn 
            v-if="item.id_status_chamado < 5"
            small 
            color="primary" 
            @click="openMenu(item)"
          >
            <v-icon small left>mdi-cog</v-icon>
            Opções
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Cards Mobile -->
    <div v-if="isMobile">
      <v-row>
        <v-col cols="12" v-for="chamado in filteredChamados" :key="chamado.id">
          <v-card elevation="2" class="mb-3">
            <!-- Header do Card -->
            <v-card-title class="primary white--text py-2">
              <div class="d-flex justify-space-between align-center w-100">
                <span class="text-h6">#{{ chamado.id }}</span>


                <v-chip 
                  small 
                  color="red"
                  text-color="white"
                >
                M:{{ chamado.maquina.id}}
                 </v-chip>



                <v-chip 
                  small 
                  :color="getStatusColor(chamado.status_chamado.id)"
                  text-color="white"
                >
                  {{ chamado.status_chamado.descricao_status }}
                </v-chip>

              </div>
            </v-card-title>

            <!-- Conteúdo do Card -->
            <v-card-text class="pb-2">
              <v-row dense>


                <v-col cols="12">
                  <div class="d-flex align-center mb-2">
                    <v-icon small color="primary" class="mr-2">mdi-account-wrench</v-icon>
                    <strong>Mecânico:</strong>
                    <span class="ml-1"> #{{ chamado.mecanico.id }} - {{ chamado.mecanico.nome_mecanico }}</span>
                  </div>
                </v-col>



                <v-col cols="12">
                  <div class="d-flex align-center mb-2">
                    <v-icon small color="primary" class="mr-2">mdi-tools</v-icon>
                    <strong>Máquina:</strong>
                    <span class="ml-1"> #{{ chamado.maquina.id }} - {{ chamado.maquina.descricao_maquina }}</span>
                  </div>
                </v-col>
                
                <v-col cols="6">
                  <div class="d-flex align-center mb-1">
                    <v-icon small color="info" class="mr-1">mdi-flag</v-icon>
                    <v-chip 
                      x-small 
                      :color="getPrioridadeColor(chamado.prioridade.id)"
                      text-color="white"
                    >
                      {{ chamado.prioridade.prioridade }}
                    </v-chip>
                  </div>
                </v-col>
                
                <v-col cols="6">
                  <div class="d-flex align-center mb-1">
                    <v-icon small color="warning" class="mr-1">mdi-clock</v-icon>
                    <span class="text-caption">{{ chamado.tempo_chamado_aberto }} min</span>
                  </div>
                </v-col>
                
                <v-col cols="12">
                  <div class="d-flex align-center mb-1">
                    <v-icon small color="success" class="mr-2">mdi-account</v-icon>
                    <span class="text-body-2">{{ chamado.funcionario_abertura.nome }}</span>
                  </div>
                </v-col>
                
                <v-col cols="12">
                  <div class="d-flex align-center">
                    <v-icon small color="secondary" class="mr-2">mdi-domain</v-icon>
                    <span class="text-body-2">{{ chamado.setor.descricao_setor }}</span>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>

            <!-- Ações do Card -->
            <v-card-actions>
              <v-btn 
                small 
                color="info" 
                text 
                @click="openMachineDialog(chamado)"
              >
                <v-icon small left>mdi-eye</v-icon>
                Máquina
              </v-btn>
              
              <v-spacer></v-spacer>
              
              <v-btn 
                v-if="chamado.id_status_chamado < 5"
                small 
                color="primary" 
                @click="openMenu(chamado)"
              >
                <v-icon small left>mdi-cog</v-icon>
                Opções
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </div>

<!-- ✅ DIÁLOGO DE MENU DE OPÇÕES MELHORADO -->
<v-dialog v-model="dialogMenuOpcoes" max-width="600" persistent>
  <v-card class="menu-opcoes-card" elevation="12">
    <!-- Header Moderno -->
    <v-card-title class="d-flex align-center pa-4 menu-header">
  <v-avatar size="40" color="white" variant="tonal" class="mr-3">
    <v-icon color="primary" size="24">mdi-cog-outline</v-icon>
  </v-avatar>
  <div class="flex-grow-1">
    <div class="text-h6 font-weight-bold text-white">Opções do Chamado</div>
    <div class="text-body-2 text-white opacity-90">
      <!-- ✅ VERIFICAÇÃO SEGURA -->
      #{{ chamadoAtual?.id || 'N/A' }} - {{ 
        (chamadoAtual?.descricao_problema || chamadoAtual?.observacao_abertura || 'Sem descrição').substring(0, 30) 
      }}{{ (chamadoAtual?.descricao_problema || chamadoAtual?.observacao_abertura || '').length > 30 ? '...' : '' }}
    </div>
  </div>
  <!-- ✅ USAR STATUS CORRETO -->
  <v-chip 
    :color="getStatusChipColor(chamadoAtual?.status_chamado?.descricao_status)" 
    size="small" 
    variant="elevated"
    class="ml-2"
  >
    {{ chamadoAtual?.status_chamado?.descricao_status || 'Sem Status' }}
  </v-chip>
</v-card-title>


    <v-divider></v-divider>

    <!-- Conteúdo das Opções -->
    <v-card-text class="pa-0">
      <div class="opcoes-container">
        <!-- Solicitar Mecânico -->
        <v-card 
          v-if="condicaoSolicitarMecanico"
          @click="opcaoSelecionada('solicitarMecanico')"
          class="opcao-card ma-3"
          variant="outlined"
          hover
        >
          <v-card-text class="d-flex align-center pa-4">
            <v-avatar size="48" color="primary" variant="tonal" class="mr-4">
              <v-icon color="primary" size="24">mdi-account-plus</v-icon>
            </v-avatar>
            <div class="flex-grow-1">
              <div class="text-subtitle-1 font-weight-bold text-primary">
                Solicitar Mecânico
              </div>
              <div class="text-body-2 text-grey-darken-1">
                Adicionar mecânico especializado ao chamado
              </div>
            </div>
            <v-icon color="grey" size="20">mdi-chevron-right</v-icon>
          </v-card-text>
        </v-card>

        <!-- Iniciar Trabalho -->
        <v-card 
          v-if="condicaoInicioTrabalhoMecanico"
          @click="opcaoSelecionada('InicioTrabalhoMecanico')"
          class="opcao-card ma-3"
          variant="outlined"
          hover
        >
          <v-card-text class="d-flex align-center pa-4">
            <v-avatar size="48" color="success" variant="tonal" class="mr-4">
              <v-icon color="success" size="24">mdi-play-circle</v-icon>
            </v-avatar>
            <div class="flex-grow-1">
              <div class="text-subtitle-1 font-weight-bold text-success">
                Iniciar Trabalho
              </div>
              <div class="text-body-2 text-grey-darken-1">
                Dar início ao atendimento do mecânico
              </div>
            </div>
            <v-chip color="success" size="small" variant="tonal">
              <v-icon start size="12">mdi-clock-start</v-icon>
              Iniciar
            </v-chip>
          </v-card-text>
        </v-card>

        <!-- Execução em Curso -->
        <v-card 
          v-if="condicaoExecucaoEmCurso"
          @click="opcaoSelecionada('execucaoEmCurso')"
          class="opcao-card ma-3"
          variant="outlined"
          hover
        >
          <v-card-text class="d-flex align-center pa-4">
            <v-avatar size="48" color="warning" variant="tonal" class="mr-4">
              <v-icon color="warning" size="24">mdi-cog-sync</v-icon>
            </v-avatar>
            <div class="flex-grow-1">
              <div class="text-subtitle-1 font-weight-bold text-warning">
                Execução em Curso
              </div>
              <div class="text-body-2 text-grey-darken-1">
                Atualizar progresso e andamento do atendimento
              </div>
            </div>
            <v-chip color="warning" size="small" variant="tonal">
              <v-icon start size="12">mdi-progress-clock</v-icon>
              Em Curso
            </v-chip>
          </v-card-text>
        </v-card>

        <!-- Enviar WhatsApp -->
        <v-card 
          v-if="condicaoEnviarWatzap"
          @click="opcaoSelecionada('enviarWhatzap')"
          class="opcao-card ma-3"
          variant="outlined"
          hover
        >
          <v-card-text class="d-flex align-center pa-4">
            <v-avatar size="48" color="green" variant="tonal" class="mr-4">
              <v-icon color="green" size="24">mdi-whatsapp</v-icon>
            </v-avatar>
            <div class="flex-grow-1">
              <div class="text-subtitle-1 font-weight-bold text-green">
                Enviar WhatsApp
              </div>
              <div class="text-body-2 text-grey-darken-1">
                Notificar responsáveis via WhatsApp
              </div>
            </div>
            <v-chip color="green" size="small" variant="tonal">
              <v-icon start size="12">mdi-send</v-icon>
              Notificar
            </v-chip>
          </v-card-text>
        </v-card>

        <!-- Finalizar Chamado -->
        <v-card 
          v-if="condicaofinalizarChamado"
          @click="opcaoSelecionada('finalizarChamado')"
          class="opcao-card ma-3"
          variant="outlined"
          hover
        >
          <v-card-text class="d-flex align-center pa-4">
            <v-avatar size="48" color="success" variant="tonal" class="mr-4">
              <v-icon color="success" size="24">mdi-check-circle</v-icon>
            </v-avatar>
            <div class="flex-grow-1">
              <div class="text-subtitle-1 font-weight-bold text-success">
                Finalizar Chamado
              </div>
              <div class="text-body-2 text-grey-darken-1">
                Concluir atendimento e fechar chamado
              </div>
            </div>
            <v-chip color="success" size="small" variant="elevated">
              <v-icon start size="12">mdi-check-bold</v-icon>
              Finalizar
            </v-chip>
          </v-card-text>
        </v-card>

        <!-- Cancelar Chamado -->
        <v-card 
          v-if="condicaoCancelarChamado"
          @click="opcaoSelecionada('cancelarChamado')"
          class="opcao-card ma-3"
          variant="outlined"
          hover
        >
          <v-card-text class="d-flex align-center pa-4">
            <v-avatar size="48" color="error" variant="tonal" class="mr-4">
              <v-icon color="error" size="24">mdi-close-circle</v-icon>
            </v-avatar>
            <div class="flex-grow-1">
              <div class="text-subtitle-1 font-weight-bold text-error">
                Cancelar Chamado
              </div>
              <div class="text-body-2 text-grey-darken-1">
                Cancelar atendimento e arquivar chamado
              </div>
            </div>
            <v-chip color="error" size="small" variant="tonal">
              <v-icon start size="12">mdi-cancel</v-icon>
              Cancelar
            </v-chip>
          </v-card-text>
        </v-card>

        <!-- Mensagem quando não há opções -->
        <div v-if="!temOpcoesDisponiveis" class="text-center pa-6">
          <v-avatar size="64" color="grey-lighten-3" class="mb-3">
            <v-icon size="32" color="grey">mdi-information-outline</v-icon>
          </v-avatar>
          <div class="text-h6 text-grey mb-2">Nenhuma ação disponível</div>
          <div class="text-body-2 text-grey">
            Não há opções disponíveis para este chamado no momento.
          </div>
        </div>
      </div>
    </v-card-text>

    <v-divider></v-divider>

    <!-- Footer com Ações -->
    <v-card-actions class="pa-4">
      <div class="d-flex align-center">
        <v-icon size="16" color="grey" class="mr-1">mdi-information</v-icon>
        <span class="text-caption text-grey">
          Selecione uma ação para continuar
        </span>
      </div>
      <v-spacer></v-spacer>
      <v-btn 
        @click="dialogMenuOpcoes = false"
        variant="outlined"
        color="grey"
        size="large"
      >
        <v-icon start>mdi-close</v-icon>
        Fechar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    <!-- Diálogo de Filtros Mobile -->
    <v-dialog v-model="filtrosDialogVisible" fullscreen persistent>
      <v-card>
        <v-card-title class="primary white--text" style="padding: 16px 24px;">
          <v-icon left color="white" size="24">mdi-filter-variant</v-icon>
          <span class="font-weight-medium">Filtros</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-select
            v-model="filtroTipoManutencao"
            :items="tiposDeManutencao"
            label="Tipo de Manutenção"
            outlined
            clearable
          ></v-select>
          <v-select
            v-model="filtroPrioridade"
            :items="prioridades"
            label="Prioridade"
            outlined
            clearable
          ></v-select>
          <v-select
            v-model="filtroStatus"
            :items="statusChamados"
            label="Status"
            outlined
            clearable
          ></v-select>
          <v-select
            v-model="filtroMecanico"
            :items="mecanicosDosChamados"
            label="Mecânico"
            outlined
            clearable
          ></v-select>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text @click="limparFiltros">Limpar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="aplicarFiltros">Aplicar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

<!-- ✅ DIÁLOGO DE SELEÇÃO DE MECÂNICO MELHORADO -->
<v-dialog v-model="dialogMecanico" max-width="700" persistent>
  <v-card class="mecanico-dialog-card" elevation="12">
    <!-- Header Moderno -->
    <v-card-title class="d-flex align-center pa-4 mecanico-header">
      <v-avatar size="40" color="white" variant="tonal" class="mr-3">
        <v-icon color="primary" size="24">mdi-account-wrench</v-icon>
      </v-avatar>
      <div class="flex-grow-1">
        <div class="text-h6 font-weight-bold text-white">Selecionar Mecânico</div>
        <div class="text-body-2 text-white opacity-90">
          Chamado #{{ chamadoAtual?.id }} - Escolha o mecânico responsável
        </div>
      </div>
      <v-chip 
        color="white" 
        variant="elevated"
        size="small"
        class="ml-2"
      >
        <v-icon start size="12" color="primary">mdi-account-group</v-icon>
        {{ getMecanicosFiltrados().length }} disponíveis
      </v-chip>
    </v-card-title>

    <v-divider></v-divider>

    <!-- Conteúdo -->
    <v-card-text class="pa-4">
      <!-- Campo de Pesquisa Melhorado -->
      <v-text-field
        v-model="searchMecanico"
        label="Pesquisar mecânico por nome"
        prepend-inner-icon="mdi-magnify"
        variant="outlined"
        clearable
        density="comfortable"
        class="mb-4 search-field"
        hide-details
      >
        <template v-slot:append-inner>
          <v-fade-transition>
            <v-icon 
              v-if="searchMecanico" 
              color="success" 
              size="20"
            >
              mdi-check-circle
            </v-icon>
          </v-fade-transition>
        </template>
      </v-text-field>

      <!-- Lista de Mecânicos -->
      <div class="mecanicos-container">
        <div v-if="getMecanicosFiltrados().length === 0" class="text-center pa-6">
          <v-avatar size="64" color="grey-lighten-3" class="mb-3">
            <v-icon size="32" color="grey">mdi-account-search</v-icon>
          </v-avatar>
          <div class="text-h6 text-grey mb-2">Nenhum mecânico encontrado</div>
          <div class="text-body-2 text-grey">
            Tente ajustar os termos de pesquisa
          </div>
        </div>

        <v-row v-else>
          <v-col 
            v-for="mecanico in getMecanicosFiltrados()" 
            :key="mecanico.id"
            cols="12" sm="6"
          >
            <v-card
              @click="selectMecanico(mecanico)"
              :class="{ 
                'mecanico-card-selected': mecanicoSelecionado?.id === mecanico.id,
                'mecanico-card': mecanicoSelecionado?.id !== mecanico.id
              }"
              variant="outlined"
              hover
              class="cursor-pointer"
            >
              <v-card-text class="d-flex align-center pa-3">
                <!-- Avatar do Mecânico -->
                <v-avatar 
                  size="48" 
                  :color="mecanicoSelecionado?.id === mecanico.id ? 'primary' : 'grey-lighten-2'" 
                  variant="tonal" 
                  class="mr-3"
                >
                  <v-icon 
                    :color="mecanicoSelecionado?.id === mecanico.id ? 'white' : 'grey'" 
                    size="24"
                  >
                    mdi-account-wrench
                  </v-icon>
                </v-avatar>

                <!-- Informações do Mecânico -->
                <div class="flex-grow-1">
                  <div 
                    class="text-subtitle-1 font-weight-bold"
                    :class="mecanicoSelecionado?.id === mecanico.id ? 'text-primary' : ''"
                  >
                    {{ mecanico.nome_mecanico }}
                  </div>
                  <div class="text-body-2 text-grey-darken-1">
                    <v-icon size="14" class="mr-1">mdi-phone</v-icon>
                    {{ mecanico.fone || "Sem telefone informado" }}
                  </div>
                </div>

                <!-- Indicador de Seleção -->
                <div class="text-center">
                  <v-fade-transition>
                    <v-icon 
                      v-if="mecanicoSelecionado?.id === mecanico.id"
                      color="primary" 
                      size="24"
                    >
                      mdi-check-circle
                    </v-icon>
                    <v-icon 
                      v-else
                      color="grey-lighten-1" 
                      size="20"
                    >
                      mdi-circle-outline
                    </v-icon>
                  </v-fade-transition>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-card-text>

    <v-divider></v-divider>

    <!-- Footer com Ações -->
    <v-card-actions class="pa-4">
      <div class="d-flex align-center">
        <v-icon size="16" color="grey" class="mr-1">mdi-information</v-icon>
        <span class="text-caption text-grey">
          {{ mecanicoSelecionado ? `Selecionado: ${mecanicoSelecionado.nome_mecanico}` : 'Selecione um mecânico para continuar' }}
        </span>
      </div>
      <v-spacer></v-spacer>
      
      <v-btn 
        @click="cancelarMecanico"
        variant="outlined"
        color="grey"
        size="large"
        class="mr-2"
      >
        <v-icon start>mdi-close</v-icon>
        Cancelar
      </v-btn>
      
      <v-btn 
        @click="salvarMecanico"
        color="primary"
        variant="elevated"
        size="large"
        :disabled="!mecanicoSelecionado"
      >
        <v-icon start>mdi-check</v-icon>
        Confirmar Seleção
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
    <!-- Componente de Máquina -->
    <ComponenteMaquinaDialog 
      :idMaquina="selectedItemId" 
      :ativa="modalVisible" 
      :habilitarSelecao="false"
      @update:ativa="modalVisible = $event" 
      @close="closeModal" 
      @maquina-selecionada="handleMaquinaSelecionada" 
    />
  </v-container>
</template>

<script>
import ComponenteMaquinaDialog from "@/components/ComponenteMaquinaDialog.vue";
import { chamadosService } from "@/services/chamadosService";
import { mecanicosService } from "@/services/mecanicosService";

import { whatZapService } from "@/services/whatZapService"; // ✅ ADICIONAR ESTA LINHA

import { useDisplay } from "vuetify";
import { useToast } from "vue-toastification";
import { useUserStore } from "@/store/userStore";

const toast = useToast();

export default {
  components: {
    ComponenteMaquinaDialog,
  },
  data() {
    return {  
      mecanicos: [],
      tituloDialog: "",
      telefone: "558199815373",
      dialogWatzap: false,
      mensagemWhatzap: "",
      pessoasReceberMensagens: [],
      idStatusFinalizacao: null,
      dialogInicioTrabalho: false,
      dialogExecucaoCurso: false,
      dialogFinalizarAtendimento: false,
      observacaoFinalizarAtendimento: "",
      observacaoMecanico: "",
      dialogCancelarChamado: false,
      observacaoCancelamento: "",
      dialogMenuOpcoes: false,
      mensagemDialog: "Carregando dados...",
      chamados: [],
      options: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] },
      headers: [
        { title: "Ações", value: "actions", sortable: false, width: "120px" },
        { title: "ID", value: "id", sortable: true, width: "80px" },
        { title: "Status", value: "status_chamado.descricao_status", sortable: true, width: "150px" },
        { title: "Funcionário", value: "funcionario_abertura.nome", sortable: true, width: "200px" },
        { title: "Setor", value: "setor.descricao_setor", sortable: true, width: "150px" },
        { title: "Prioridade", value: "prioridade.prioridade", sortable: true, width: "120px" },
        { title: "Tipo Manutenção", value: "tipo_manutencao.tipo_manutencao", sortable: true, width: "180px" },
        { title: "Observação", value: "observacao_abertura", sortable: false, width: "300px" },
        { title: "Máquina", value: "maquina.descricao_maquina", sortable: true, width: "250px" },
        { title: "Abertura", value: "data_abertura", sortable: true, width: "150px" },
        { title: "Tempo (min)", value: "tempo_chamado_aberto", sortable: true, width: "120px" },
      ],
      search: "",
      filtroTipoManutencao: null,
      filtroPrioridade: null,
      filtroStatus: null,
      filtroMecanico: null,
      loadingDialog: false,
      modalVisible: false,
      selectedItemId: null,
      filtrosDialogVisible: false,
      chamadoAtual: null,
      dialogMecanico: false,
      modalSucesso: false,
      mecanicoSelecionado: null,
      searchMecanico: "",
    };
  },
  computed: {
    // Adicionando userStore como propriedade computada
    userStore() {
      return useUserStore();
    },

          // ✅ CORRIGIDO - Computed sem parâmetros
    temOpcoesDisponiveis() {
      return this.condicaoSolicitarMecanico || 
             this.condicaoInicioTrabalhoMecanico || 
             this.condicaoExecucaoEmCurso || 
             this.condicaoEnviarWatzap || 
             this.condicaofinalizarChamado || 
             this.condicaoCancelarChamado;
    },

 

    usuarioMecanico() {
      return this.userStore.objetoUsuario?.funcionario?.cargo?.nome === "MECÂNICO" || false;
    },
    empresa_id() {
      return this.userStore.objetoUsuario?.funcionario?.empresa_id || null;
    },
    condicaoEnviarWatzap() {
      if (!this.chamadoAtual) return false;
      if (this.chamadoAtual.id_status_chamado == 2 || this.chamadoAtual.id_status_chamado == 3) return true;
      return false;
    },
    condicaoSolicitarMecanico() {
      if (!this.chamadoAtual) return false;
      if (this.chamadoAtual.id_status_chamado !== 1) return false;
      return true;
    },
    condicaofinalizarChamado() {
      if (!this.chamadoAtual) return false;
      if (this.chamadoAtual.id_status_chamado >= 5) return false;
      return true;
    },
    condicaoInicioTrabalhoMecanico() {
      if (!this.chamadoAtual) return false;
      if (this.chamadoAtual.id_status_chamado !== 2) return false;
      return true;
    },
    condicaoExecucaoEmCurso() {
      if (!this.chamadoAtual) return false;
      if (this.chamadoAtual.id_status_chamado !== 3) return false;
      return true;
    },
    condicaoCancelarChamado() {
      if (!this.chamadoAtual) return false;
      if (this.chamadoAtual.id_status_chamado >= 5) return false;
      return true;
    },
    isMobile() {
      const { xs } = useDisplay();
      return xs.value;
    },
    tiposDeManutencao() {
      return [...new Set(this.chamados.map(c => c.tipo_manutencao?.tipo_manutencao || "Não Especificado"))];
    },
    prioridades() {
      return [...new Set(this.chamados.map(c => c.prioridade?.prioridade || "Não Especificado"))];
    },
    statusChamados() {
      return [...new Set(this.chamados.map(c => c.status_chamado?.descricao_status || "Não Especificado"))];
    },
    mecanicosDosChamados() {
      return [...new Set(this.chamados.map(c => c.mecanico?.nome_mecanico || "Não Especificado"))];
    },
    filteredChamados() {
      return this.chamados
        .filter((chamado) => {
          const tipoManutencaoValido = !this.filtroTipoManutencao || chamado.tipo_manutencao?.tipo_manutencao === this.filtroTipoManutencao;
          const prioridadeValida = !this.filtroPrioridade || chamado.prioridade?.prioridade === this.filtroPrioridade;
          const statusValido = !this.filtroStatus || chamado.status_chamado?.descricao_status === this.filtroStatus;
          const mecanicoValido = !this.filtroMecanico || chamado.mecanico?.nome_mecanico === this.filtroMecanico;
          return tipoManutencaoValido && prioridadeValida && statusValido && mecanicoValido;
        })
        .map((chamado) => {
          const tempoChamadoAberto = chamado.tempo_chamado_aberto !== null
            ? chamado.tempo_chamado_aberto
            : chamado.data_encerramento_chamado
              ? this.diferencaMinutos(chamado.data_abertura, chamado.data_encerramento_chamado)
              : this.diferencaMinutos(chamado.data_abertura, new Date());

          const tempoChamadoMecanico = chamado.tempo_chamado_mecanico !== null
            ? chamado.tempo_chamado_mecanico
            : chamado.data_inicio_trabalho_mecanico && chamado.data_fim_trabalho_mecanico
              ? this.diferencaMinutos(chamado.data_inicio_trabalho_mecanico, chamado.data_fim_trabalho_mecanico)
              : null;

          const tempoMecanicoIniciar = chamado.data_solicitacao_mecanico
            ? chamado.data_inicio_trabalho_mecanico
              ? this.diferencaMinutos(chamado.data_solicitacao_mecanico, chamado.data_inicio_trabalho_mecanico)
              : this.diferencaMinutos(chamado.data_solicitacao_mecanico, new Date())
            : null;

          const tempoMecanicoFinalizar = chamado.data_inicio_trabalho_mecanico && chamado.data_fim_trabalho_mecanico
            ? this.diferencaMinutos(chamado.data_inicio_trabalho_mecanico, chamado.data_fim_trabalho_mecanico)
            : null;

          const tempoTotal = chamado.data_abertura && chamado.data_encerramento_chamado
            ? this.diferencaMinutos(chamado.data_abertura, chamado.data_encerramento_chamado)
            : null;

          return {
            ...chamado,
            tempo_chamado_aberto: tempoChamadoAberto !== null ? this.formatarMinutosParaHHMM(tempoChamadoAberto) : null,
            tempo_chamado_mecanico: tempoChamadoMecanico !== null ? this.formatarMinutosParaHHMM(tempoChamadoMecanico) : null,
            tempo_mecanico_iniciar: tempoMecanicoIniciar !== null ? this.formatarMinutosParaHHMM(tempoMecanicoIniciar) : null,
            tempo_mecanico_finalizar: tempoMecanicoFinalizar !== null ? this.formatarMinutosParaHHMM(tempoMecanicoFinalizar) : null,
            tempo_total: tempoTotal !== null ? this.formatarMinutosParaHHMM(tempoTotal) : null,
          };
        });
    },
  },
  methods: {

    // ✅ MOVER PARA METHODS - Função que recebe parâmetros
    getStatusChipColor(status) {
      try {
        // Verificações defensivas
        if (!status || status === null || status === undefined) {
          return 'grey';
        }
        
        // Garantir que é string e converter para lowercase
        const statusStr = String(status).trim().toLowerCase();
        
        // Mapeamento de status
        const statusMap = {
          'aberto': 'info',
          'novo': 'info',
          'pendente': 'info',
          'em andamento': 'warning',
          'em_andamento': 'warning',
          'andamento': 'warning',
          'executando': 'warning',
          'finalizado': 'success',
          'concluido': 'success',
          'concluído': 'success',
          'resolvido': 'success',
          'cancelado': 'error',
          'rejeitado': 'error',
          'pausado': 'grey',
          'aguardando': 'orange'
        };
        
        return statusMap[statusStr] || 'grey';
        
      } catch (error) {
        console.error('Erro ao determinar cor do status:', error);
        return 'grey';
      }
    },


    // Métodos auxiliares para cores
    getPrioridadeColor(prioridadeId) {
      const colors = {
        1: "success", // Baixa
        2: "warning", // Média  
        3: "error",   // Alta
        4: "red darken-4", // Crítica
      };
      return colors[prioridadeId] || "grey";
    },
    
    getStatusColor(statusId) {
      const colors = {
        1: "success",     // Aberto
        2: "info",        // Mecânico Chamado
        3: "primary",     // Trabalho Iniciado
        4: "warning",     // Pausado
        5: "error",       // Encerrado com Problemas
        6: "grey",        // Finalizado com Sucesso
        7: "red darken-4" // Cancelado
      };
      return colors[statusId] || "grey";
    },

    // Métodos para fechar diálogos
    fecharDialogFinalizacao() {
      this.dialogFinalizarAtendimento = false;
      this.observacaoFinalizarAtendimento = "";
      this.idStatusFinalizacao = null;
    },

    fecharDialogWhatsapp() {
      this.dialogWatzap = false;
      this.mensagemWhatzap = "";
    },

    fecharDialogCancelamento() {
      this.dialogCancelarChamado = false;
      this.observacaoCancelamento = "";
    },

    showObservacao(observacao) {
      alert(`Observação completa:\n\n${observacao}`);
    },

    // Métodos de navegação
    abrirChamado() {
      this.$router.push({ name: "AbrirChamadoDesktop" }).catch(() => {});
    },

    voltarMenu() {
      this.$router.push({ name: "MenuDefault" }).catch(() => {});
    },

    // Métodos de filtros
    limparFiltros() {
      this.filtroTipoManutencao = null;
      this.filtroPrioridade = null;
      this.filtroStatus = null;
      this.filtroMecanico = null;
      this.filtrosDialogVisible = false;
    },

    aplicarFiltros() {
      this.filtrosDialogVisible = false;
    },

    // Métodos de modal
    closeModal() {
      this.modalVisible = false;
      this.selectedItemId = null;
    },

    handleMaquinaSelecionada() {
      this.modalVisible = false;
      this.selectedItemId = null;
    },

    openMachineDialog(item) {
      this.selectedItemId = item.id_maquina;
      this.modalVisible = true;
    },

    openMenu(item) {
      this.chamadoAtual = item;
      this.dialogMenuOpcoes = true;
    },

    // Métodos de formatação
    formatarDataHora(data) {
      if (!data) return null;
      const date = new Date(data);
      const dia = date.getDate().toString().padStart(2, "0");
      const mes = (date.getMonth() + 1).toString().padStart(2, "0");
      const ano = date.getFullYear();
      const horas = date.getHours().toString().padStart(2, "0");
      const minutos = date.getMinutes().toString().padStart(2, "0");
      return `${dia}-${mes}-${ano} ${horas}:${minutos}`;
    },

    formatarMinutosParaHHMM(minutos) {
      const horas = Math.floor(minutos / 60);
      const minutosRestantes = minutos % 60;
      return `${horas.toString().padStart(2, "0")}:${minutosRestantes.toString().padStart(2, "0")}`;
    },

    diferencaMinutos(dataInicio, dataFim) {
      const inicio = new Date(dataInicio);
      const fim = new Date(dataFim);
      return Math.floor((fim - inicio) / 60000);
    },

    // Métodos de opções
    opcaoSelecionada(acao) {
      this.dialogMenuOpcoes = false;
      switch (acao) {
        case "solicitarMecanico":
          this.abrirSheetMecanico();
          break;
        case "InicioTrabalhoMecanico":
          this.iniciarTrabalhoMecanico();
          break;
        case "execucaoEmCurso":
          this.iniciarExecucaoCurso();
          break;
        case "enviarWhatzap":
          this.enviarWhatzap();
          break;
        case "finalizarChamado":
          this.dialogFinalizarAtendimento = true;
          break;
        case "cancelarChamado":
          this.dialogCancelarChamado = true;
          break;
        default:
          console.log("Ação desconhecida:", acao);
      }
    },

    iniciarTrabalhoMecanico() {
      this.dialogInicioTrabalho = true;
    },

    iniciarExecucaoCurso() {
      this.observacaoMecanico = this.chamadoAtual.observacao_mecanico;
      this.dialogExecucaoCurso = true;
    },

    // Métodos de mecânico
    async abrirSheetMecanico() {
      try {
        await this.carregarMecanicos();
        this.dialogMecanico = true;
      } catch (error) {
        console.error("Erro ao carregar mecânicos:", error);
        toast.error("Erro ao carregar mecânicos. Tente novamente.");
      }
    },

    getMecanicosFiltrados() {
      return this.mecanicos.filter((mecanico) =>
        mecanico.nome_mecanico.toLowerCase().includes(this.searchMecanico.toLowerCase())
      );
    },

    selectMecanico(mecanico) {
      this.mecanicoSelecionado = mecanico;
    },

    cancelarMecanico() {
      this.dialogMecanico = false;
      this.mecanicoSelecionado = null;
    },

    async carregarMecanicos() {
      try {
        this.loadingDialog = true;
        this.mecanicos = await chamadosService.consultaMecanicos();
        this.loadingDialog = false;
      } catch (error) {
        this.loadingDialog = false;
        console.error("Erro ao carregar mecânicos:", error);
        toast.error("Erro ao carregar mecânicos.");
      }
    },

    // Métodos de WhatsApp
    // ✅ CERTIFIQUE-SE QUE ESTÁ AQUI DENTRO
    enviarWhatzap() {
      alert('enviarWhatzap');
      const chamado = this.chamadoAtual;
      this.pessoasReceberMensagens = [];

      // ✅ PEGAR ID DO MECÂNICO DO CHAMADO
      const mecanicoAtribuidoId = chamado.mecanico?.id || chamado.id_mecanico || null;

      // ✅ USAR LISTA DE MECÂNICOS E MARCAR APENAS O ATRIBUÍDO
      this.pessoasReceberMensagens = this.mecanicos
        .filter(mecanico => mecanico.ativo === "SIM")
        .map((mecanico) => ({
          id: mecanico.id,
          nome: mecanico.nome_mecanico,
          celular: mecanico.fone,
          selecionado: (mecanico.id === mecanicoAtribuidoId) && 
                       (mecanico.fone && mecanico.fone.trim() !== "")
        }));

      // ✅ REMOVER DUPLICATAS
      this.pessoasReceberMensagens = this.pessoasReceberMensagens.filter(
        (item, index, self) => index === self.findIndex((t) => t.id === item.id)
      );

      this.mensagemWhatzap = `
**Chamado Nº**
${chamado.id}
**Tipo Manutenção:**
${chamado.tipo_manutencao.tipo_manutencao}
**Chefe de Setor:**
${chamado.funcionario_abertura.nome}
**Nº Máquina:**
 ${chamado.maquina.id}
**Máquina:**
${chamado.maquina.descricao_maquina}
**Modelo:**
${chamado.maquina.modelo}
**Setor:**
${chamado.setor.descricao_setor}
**Prioridade:**
${chamado.prioridade.prioridade}
**Fila:**
${chamado.maquina.fila} - **Posição:** ${chamado.maquina.posicao}
**Observação:**
 ${chamado.observacao_abertura || "Sem observações"}
`.trimStart();

      this.dialogWatzap = true;
    },

    // ✅ MÉTODO opcaoSelecionada DEVE ESTAR AQUI TAMBÉM
    opcaoSelecionada(acao) {
      this.dialogMenuOpcoes = false;
      switch (acao) {
        case "solicitarMecanico":
          this.abrirSheetMecanico();
          break;
        case "InicioTrabalhoMecanico":
          this.iniciarTrabalhoMecanico();
          break;
        case "execucaoEmCurso":
          this.iniciarExecucaoCurso();
          break;
        case "enviarWhatzap":
          this.enviarWhatzap(); // ✅ CHAMADA CORRETA
          break;
        case "finalizarChamado":
          this.dialogFinalizarAtendimento = true;
          break;
        case "cancelarChamado":
          this.dialogCancelarChamado = true;
          break;
        default:
          console.log("Ação desconhecida:", acao);
      }
    },




    async confirmarWhatzap() {
  this.dialogWatzap = false;
  this.mensagemDialog = "Verificando conexão do WhatsApp...";
  this.loadingDialog = true;

  try {
    // ✅ VERIFICAR STATUS DA INSTÂNCIA PRIMEIRO
    const statusCheck = await whatZapService.verificarStatusWhatsapp({
      empresa_id: 1
    });

    const statusInstancia = statusCheck?.data?.response?.instance?.state;
    const nomeInstancia = statusCheck?.data?.response?.instance?.instanceName;

    // ✅ SE NÃO ESTIVER CONECTADO, PARAR AQUI
    if (statusInstancia !== 'open') {
      this.loadingDialog = false;
      this.mostrarErroConexao(statusInstancia, nomeInstancia);
      return;
    }

    // ✅ SE CONECTADO, CONTINUAR COM ENVIO
    this.mensagemDialog = `WhatsApp conectado (${nomeInstancia})! Preparando envio...`;
    
    // ✅ FILTRAR APENAS OS SELECIONADOS (MUDANÇA AQUI)
    const pessoasSelecionadas = this.pessoasReceberMensagens.filter(
      (pessoa) => pessoa.selecionado && pessoa.celular && pessoa.celular.trim() !== ""
    );

    // ✅ LOG PARA DEBUG
    console.log("🔍 Pessoas selecionadas:", pessoasSelecionadas);
    console.log("🔍 Total de pessoas:", this.pessoasReceberMensagens);

    if (pessoasSelecionadas.length === 0) {
      this.loadingDialog = false;
      toast.warning("Nenhum mecânico selecionado ou com telefone válido para envio.");
      return;
    }

    const resultadosEnvio = [];

    // ✅ USAR pessoasSelecionadas EM VEZ DE pessoasComTelefone
    for (const pessoa of pessoasSelecionadas) {
      this.mensagemDialog = `Enviando para: ${pessoa.nome} (${pessoa.celular})`;

      try {
        const mensagemData = {
          telefone: pessoa.celular.trim(),
          texto: this.mensagemWhatzap.trim(),
          empresa_id: 1,
        };

        const response = await chamadosService.enviarWhatsapp(mensagemData);

        if (response && response.data) {
          const { status, message, codigo_erro } = response.data;

          // ✅ TRATAR DIFERENTES TIPOS DE RESPOSTA
          if (status === "sucesso" || status === "Processando") {
            resultadosEnvio.push({
              pessoa: pessoa.nome,
              telefone: pessoa.celular,
              status: "✅ Enviado com sucesso",
              detalhes: message || "Mensagem processada"
            });
          } else if (codigo_erro === "INSTANCE_NOT_CONNECTED") {
            // ✅ SE DESCONECTOU DURANTE O ENVIO
            this.loadingDialog = false;
            this.mostrarErroConexao("close", nomeInstancia);
            return;
          } else {
            resultadosEnvio.push({
              pessoa: pessoa.nome,
              telefone: pessoa.celular,
              status: "❌ Erro no envio",
              detalhes: message || "Status inválido"
            });
          }
        } else {
          resultadosEnvio.push({
            pessoa: pessoa.nome,
            telefone: pessoa.celular,
            status: "❌ Erro no servidor",
            detalhes: "Resposta inválida do servidor"
          });
        }
      } catch (error) {
        console.error(`Erro ao enviar mensagem para ${pessoa.nome}:`, error);
        
        // ✅ TRATAR ERROS ESPECÍFICOS
        let statusErro = "❌ Erro desconhecido";
        let detalhes = error.message || "Erro ao enviar mensagem";
        
        if (error.response?.data?.codigo_erro === "INSTANCE_NOT_CONNECTED") {
          this.loadingDialog = false;
          this.mostrarErroConexao("close", nomeInstancia);
          return;
        } else if (error.response?.status === 408) {
          statusErro = "❌ Timeout";
          detalhes = "WhatsApp demorou para responder";
        } else if (error.response?.data?.message) {
          detalhes = error.response.data.message;
        }
        
        resultadosEnvio.push({
          pessoa: pessoa.nome,
          telefone: pessoa.celular,
          status: statusErro,
          detalhes: detalhes
        });
      }

      // ✅ AGUARDAR ENTRE ENVIOS (3 segundos) - APENAS SE HOUVER MAIS DE UM
      if (pessoasSelecionadas.length > 1) {
        await new Promise((resolve) => setTimeout(resolve, 3000));
      }
    }

    // ✅ MOSTRAR RESULTADO FINAL
    this.mensagemDialog = "Envio Concluído!";
    this.mostrarRelatorioEnvio(resultadosEnvio);
    this.modalSucesso = true;
    
  } catch (error) {
    console.error("Erro geral ao enviar mensagens:", error);
    this.mostrarErroGeral(error);
  } finally {
    this.loadingDialog = false;
  }
},



// ✅ ADICIONAR ESTES MÉTODOS NO SEU SCRIPT

// Método para mostrar erro de conexão
mostrarErroConexao(status, instancia) {
  const config = whatZapService.getConfigErroConexao(status, instancia);
  
  // ✅ NOTIFICAÇÃO COM TOAST
  toast.error(config.texto);

  // ✅ OPÇÃO DE REDIRECIONAR PARA CONFIGURAÇÕES
  toast.info("Clique aqui para ir às configurações do WhatsApp", {
    onClick: () => {
      this.$router.push({ name: 'WhatsAppConfigMobile' });
    },
    timeout: 5000
  });
},

// Método para mostrar relatório de envio
mostrarRelatorioEnvio(resultados) {
  const relatorio = whatZapService.analisarResultadosEnvio(resultados);
  
  console.table(resultados);
  
  // ✅ NOTIFICAÇÕES BASEADAS NO RESULTADO
  if (relatorio.todosComSucesso) {
    toast.success(`✅ Todas as ${relatorio.sucessos} mensagens foram enviadas com sucesso!`);
  } else if (relatorio.sucessos > 0 && relatorio.erros > 0) {
    toast.warning(`⚠️ ${relatorio.sucessos} enviadas, ${relatorio.erros} com erro.`);
    
    // Mostrar detalhes dos erros
    const pessoasComErro = relatorio.pessoasComErro
      .map(item => item.nome)
      .join(', ');
    
    toast.error(`❌ Erros para: ${pessoasComErro}`, { timeout: 8000 });
  } else if (relatorio.todosFalharam) {
    toast.error(`❌ Todas as ${relatorio.erros} mensagens falharam.`);
  }

  // ✅ LOG DETALHADO PARA DEBUG
  console.log("📊 Relatório de Envio:", relatorio);
},

// Método para mostrar erro geral
mostrarErroGeral(error) {
  const mensagemErro = error.message || 'Erro desconhecido ao enviar mensagens';
  toast.error(`❌ ${mensagemErro}`);
  
  console.error("Erro detalhado:", error);
},



    // Métodos de ações do chamado
    async salvarMecanico() {
      if (!this.mecanicoSelecionado) {
        toast.error("Selecione um mecânico para continuar.");
        return;
      }
      this.mensagemDialog = "Adicionando mecânico ao chamado...";
      this.loadingDialog = true;

      try {
        const chamadoData = {
          id_chamado: this.chamadoAtual?.id,
          id_mecanico: this.mecanicoSelecionado?.id,
        };

        if (!chamadoData.id_chamado || !chamadoData.id_mecanico) {
          throw new Error("Dados inválidos para adicionar o mecânico.");
        }

        const response = await chamadosService.chamadoAdicionarMecanico(chamadoData);
        const { status, chamado } = response.data;

        if (status === "success") {
          this.chamadoAtual.id_mecanico = chamado.id_mecanico || chamadoData.id_mecanico;
          this.chamadoAtual.data_solicitacao_mecanico = chamado.data_abertura;
          this.mensagemDialog = "Mecânico Adicionado";
          this.modalSucesso = true;
          toast.success("Mecânico adicionado ao chamado com sucesso.");
        } else {
          throw new Error("Erro ao adicionar mecânico.");
        }
      } catch (error) {
        console.error("Erro ao adicionar mecânico:", error.message);
        toast.error(error.message || "Erro ao adicionar mecânico ao chamado.");
      } finally {
        this.dialogMecanico = false;
        this.loadingDialog = false;
      }
    },

    async confirmarInicioTrabalho() {
      this.dialogInicioTrabalho = false;
      this.mensagemDialog = "Iniciando Trabalho...";
      this.loadingDialog = true;

      try {
        const chamadoData = {
          id_chamado: this.chamadoAtual.id,
        };

        if (!chamadoData.id_chamado) {
          throw new Error("Dados inválidos para iniciar o trabalho.");
        }

        const response = await chamadosService.chamadoIniciarTrabalho(chamadoData);
        const { status, chamado } = response.data;

        if (status === "success") {
          this.chamadoAtual.id_mecanico = chamado.id_mecanico || chamadoData.id_mecanico;
          this.chamadoAtual.data_solicitacao_mecanico = chamado.data_abertura;
          this.mensagemDialog = "Inicio do trabalho iniciado";
          this.modalSucesso = true;
          toast.success("Inicio do trabalho iniciado.");
        } else {
          throw new Error("Erro ao iniciar o trabalho.");
        }
      } catch (error) {
        console.error("Erro ao iniciar o trabalho:", error.message);
        toast.error(error.message || "Erro ao iniciar o trabalho.");
      } finally {
        this.loadingDialog = false;
      }
    },

    async confirmarExecucaoCurso() {
      this.dialogExecucaoCurso = false;
      this.mensagemDialog = "Salvando Observação...";
      this.loadingDialog = true;

      try {
        const chamadoData = {
          id_chamado: this.chamadoAtual.id,
          observacao_mecanico: this.observacaoMecanico,
        };

        if (!chamadoData.id_chamado) {
          throw new Error("Dados inválidos para atualizar execução.");
        }

        const response = await chamadosService.chamadoExecucaoCurso(chamadoData);
        const { status, chamado } = response.data;

        if (status === "success") {
          this.chamadoAtual.id_mecanico = chamado.id_mecanico || chamadoData.id_mecanico;
          this.chamadoAtual.data_solicitacao_mecanico = chamado.data_abertura;
          this.mensagemDialog = "Observação Salva";
          this.modalSucesso = true;
          toast.success("Execução em curso atualizada.");
        } else {
          throw new Error("Erro ao atualizar execução.");
        }
      } catch (error) {
        console.error("Erro ao atualizar execução:", error.message);
        toast.error(error.message || "Erro ao atualizar execução.");
      } finally {
        this.loadingDialog = false;
      }
    },

    async confirmarFinalizarAtendimento() {
      this.dialogFinalizarAtendimento = false;
      this.mensagemDialog = "Finalizando Chamado...";
      this.loadingDialog = true;

      try {
        const chamadoData = {
          id_chamado: this.chamadoAtual.id,
          observacao_encerramento: this.observacaoFinalizarAtendimento,
          id_status_chamado: this.idStatusFinalizacao,
        };

        if (!chamadoData.id_chamado) {
          throw new Error("Dados inválidos para finalizar chamado.");
        }

        const response = await chamadosService.chamadoFinalizar(chamadoData);
        const { status, chamado } = response.data;

        if (status === "success") {
          this.chamadoAtual.id_mecanico = chamado.id_mecanico || chamadoData.id_mecanico;
          this.chamadoAtual.data_solicitacao_mecanico = chamado.data_abertura;
          this.mensagemDialog = "Chamado Finalizado";
          this.modalSucesso = true;
          toast.success("Chamado finalizado com sucesso.");
        } else {
          throw new Error("Erro ao finalizar chamado.");
        }
      } catch (error) {
        console.error("Erro ao finalizar chamado:", error.message);
        toast.error(error.message || "Erro ao finalizar chamado.");
      } finally {
        this.loadingDialog = false;
      }
    },

    async cancelarChamado() {
      this.dialogCancelarChamado = false;
      this.loadingDialog = true;
      this.mensagemDialog = "Cancelando chamado...";

      try {
        const chamadoData = {
          id_chamado: this.chamadoAtual.id,
          observacao_Cancelamento: this.observacaoCancelamento,
        };

        if (!chamadoData.id_chamado || !this.observacaoCancelamento) {
          throw new Error("Dados inválidos para cancelar o chamado.");
        }

        const response = await chamadosService.chamadoCancelar(chamadoData);
        const { status, chamado } = response.data;

        if (status === "success") {
          this.mensagemDialog = "Cancelado";
          this.modalSucesso = true;
          toast.success("Chamado cancelado com sucesso.");
        } else {
          throw new Error("Erro ao cancelar chamado.");
        }
      } catch (error) {
        console.error("Erro ao cancelar chamado:", error.message);
        toast.error(error.message || "Erro ao cancelar chamado.");
      } finally {
        this.loadingDialog = false;
      }
    },

    // Método principal para buscar chamados
    async fetchChamados() {
      this.mensagemDialog = "Carregando Chamados...";
      this.modalSucesso = false;
      this.loadingDialog = true;

      try {
        this.chamados = await chamadosService.obterTodos();
      } catch (error) {
        console.error("Erro ao buscar chamados:", error);
        this.chamados = [];
        toast.error("Erro ao carregar chamados");
      } finally {
        this.loadingDialog = false;
      }


      try {
        this.mecanicos = await mecanicosService.obterTodos();
      } catch (error) {
        console.error("Erro ao buscar mecanicos:", error);
        this.mecanicos = [];
        toast.error("Erro ao carregar mecanicos");
      } finally {
        this.loadingDialog = false;
      }
    },
  },
  created() {
    this.fetchChamados();
  },
};
</script>

<style scoped>
.hoverable {
  transition: background-color 0.2s ease;
}

.hoverable:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.w-100 {
  width: 100%;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.overflow-y-auto {
  overflow-y: auto;
}

/* Melhorias visuais */
.v-card {
  border-radius: 8px !important;
}

.v-chip {
  font-weight: 500;
}

.v-list-item--active {
  background-color: rgba(25, 118, 210, 0.1);
}

/* Responsividade melhorada */
@media (max-width: 600px) {
  .v-card-title {
    font-size: 1.1rem !important;
  }
  
  .v-card-text {
    padding: 12px !important;
  }
}

/* Estilos para melhor aparência */
.primary--text {
  color: #1976d2 !important;
}

.success--text {
  color: #4caf50 !important;
}

.error--text {
  color: #f44336 !important;
}

.warning--text {
  color: #ff9800 !important;
}

/* Animações suaves */
.v-dialog {
  transition: all 0.3s ease;
}

.v-card {
  transition: all 0.2s ease;
}

.v-btn {
  transition: all 0.2s ease;
}

/* Melhorias para mobile */
@media (max-width: 768px) {
  .v-container {
    padding: 8px !important;
  }
  
  .v-card {
    margin-bottom: 8px !important;
  }
  
  .v-btn {
    min-width: auto !important;
  }


}
.menu-opcoes-card {
  border-radius: 16px !important;
  overflow: hidden;
}

.menu-header {
  background: linear-gradient(135deg, #1976d2 0%, #2196f3 100%);
  position: relative;
}

.menu-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05));
  pointer-events: none;
}

.opcoes-container {
  max-height: 500px;
  overflow-y: auto;
}

.opcao-card {
  transition: all 0.3s ease;
  cursor: pointer;
  border-radius: 12px !important;
  border: 2px solid transparent !important;
}

.opcao-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1) !important;
  border-color: rgba(25, 118, 210, 0.3) !important;
}

.opcao-card:active {
  transform: translateY(0);
}

/* Animações */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.opcao-card {
  animation: slideInUp 0.4s ease;
}

.opcao-card:nth-child(2) {
  animation-delay: 0.1s;
}

.opcao-card:nth-child(3) {
  animation-delay: 0.2s;
}

.opcao-card:nth-child(4) {
  animation-delay: 0.3s;
}

.opcao-card:nth-child(5) {
  animation-delay: 0.4s;
}

.opcao-card:nth-child(6) {
  animation-delay: 0.5s;
}

/* Scrollbar customizada */
.opcoes-container::-webkit-scrollbar {
  width: 6px;
}

.opcoes-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.opcoes-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.opcoes-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsividade */
@media (max-width: 600px) {
  .opcao-card {
    margin: 8px !important;
  }
  
  .opcao-card .v-card-text {
    padding: 12px !important;
  }
  
  .menu-header .text-h6 {
    font-size: 1.1rem !important;
  }
}


/* ✅ ESTILOS PARA O DIÁLOGO DE MECÂNICO */
.mecanico-dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
}

.mecanico-header {
  background: linear-gradient(135deg, #1976d2 0%, #2196f3 100%);
  position: relative;
}

.mecanico-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05));
  pointer-events: none;
}

.mecanicos-container {
  max-height: 400px;
  overflow-y: auto;
}

.search-field {
  transition: all 0.3s ease;
}

.search-field:focus-within {
  transform: scale(1.02);
}

.mecanico-card {
  transition: all 0.3s ease;
  border-radius: 12px !important;
  border: 2px solid transparent !important;
}

.mecanico-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1) !important;
  border-color: rgba(25, 118, 210, 0.3) !important;
}

.mecanico-card-selected {
  transition: all 0.3s ease;
  border-radius: 12px !important;
  border: 2px solid #1976d2 !important;
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.05), rgba(33, 150, 243, 0.02));
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(25, 118, 210, 0.2) !important;
}

.mecanico-card-selected:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(25, 118, 210, 0.3) !important;
}

.cursor-pointer {
  cursor: pointer;
}

/* Animações */
@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.mecanico-card,
.mecanico-card-selected {
  animation: fadeInScale 0.4s ease;
}

.mecanico-card:nth-child(odd) {
  animation-delay: 0.1s;
}

.mecanico-card:nth-child(even) {
  animation-delay: 0.2s;
}

/* Scrollbar customizada para lista de mecânicos */
.mecanicos-container::-webkit-scrollbar {
  width: 6px;
}

.mecanicos-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.mecanicos-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.mecanicos-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsividade */
@media (max-width: 600px) {
  .mecanico-dialog-card {
    margin: 8px;
  }
  
  .mecanico-card,
  .mecanico-card-selected {
    margin-bottom: 8px;
  }
  
  .mecanico-header .text-h6 {
    font-size: 1.1rem !important;
  }
  
  .mecanicos-container {
    max-height: 300px;
  }
}

/* Efeitos de hover melhorados */
.v-btn:hover {
  transform: translateY(-1px);
}

.v-btn:active {
  transform: translateY(0);
}

/* Transições suaves */
.v-fade-transition-enter-active,
.v-fade-transition-leave-active {
  transition: opacity 0.3s ease;
}

.v-fade-transition-enter-from,
.v-fade-transition-leave-to {
  opacity: 0;
}

.loading-card {
  background: linear-gradient(135deg, #9fa4b9 0%, #5c88a5 100%);
  border: none;
  position: relative;
  overflow: hidden;
}

.loading-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, 
    rgba(255,255,255,0.1) 0%, 
    rgba(255,255,255,0.05) 50%, 
    rgba(255,255,255,0.1) 100%);
  animation: shimmer 3s ease-in-out infinite;
}

@keyframes shimmer {
  0%, 100% { transform: translateX(-100%); }
  50% { transform: translateX(100%); }
}

.loading-animation-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
}

.loading-circles {
  position: absolute;
  width: 100px;
  height: 100px;
}

.circle {
  position: absolute;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  animation: pulse 2s ease-in-out infinite;
}

.circle-1 {
  width: 60px;
  height: 60px;
  top: 20px;
  left: 20px;
  animation-delay: 0s;
}

.circle-2 {
  width: 80px;
  height: 80px;
  top: 10px;
  left: 10px;
  animation-delay: 0.5s;
}

.circle-3 {
  width: 100px;
  height: 100px;
  top: 0;
  left: 0;
  animation-delay: 1s;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(0.8);
    opacity: 0.3;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }
}

.loading-spinner {
  z-index: 2;
  filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.3));
}

.loading-title {
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.5px;
}

.typing-animation {
  display: inline-block;
  overflow: hidden;
  border-right: 2px solid white;
  white-space: nowrap;
  animation: typing 2s steps(20) infinite;
}

@keyframes typing {
  0%, 50% { border-right-color: white; }
  51%, 100% { border-right-color: transparent; }
}

.loading-subtitle {
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.progress-container {
  position: relative;
  margin: 0 20px;
}

.loading-progress {
  background-color: rgba(255, 255, 255, 0.2) !important;
  border-radius: 10px;
  overflow: hidden;
}

.loading-progress :deep(.v-progress-linear__determinate) {
  background: linear-gradient(90deg, #ff6b6b, #4ecdc4, #45b7d1, #96ceb4);
  background-size: 200% 100%;
  animation: gradient-flow 2s ease infinite;
}

@keyframes gradient-flow {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.loading-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.dot {
  width: 8px;
  height: 8px;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  animation: bounce 1.4s ease-in-out infinite both;
}

.dot:nth-child(1) { animation-delay: -0.32s; }
.dot:nth-child(2) { animation-delay: -0.16s; }
.dot:nth-child(3) { animation-delay: 0s; }

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1.2);
    opacity: 1;
  }
}

/* Tema escuro */
.v-theme--dark .loading-card {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
}

.v-theme--dark .loading-title,
.v-theme--dark .loading-subtitle {
  color: #ecf0f1;
}

</style>